/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1LocationCitiesMutationRequest,
  PostApiV1LocationCitiesMutationResponse,
  PostApiV1LocationCities400,
  PostApiV1LocationCities401,
  PostApiV1LocationCities404,
  PostApiV1LocationCities409,
  PostApiV1LocationCities500,
} from "../../types/locationCityController/PostApiV1LocationCities.ts";

function getPostApiV1LocationCitiesUrl() {
  const res = { method: "POST", url: `/api/v1/location/cities` as const };
  return res;
}

/**
 * @description Cria uma nova cidade vinculada a um estado. O código é único globalmente e o nome é único dentro do estado. **(Requer Authorization para autenticação)**
 * @summary Criar cidade (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities}
 */
export async function postApiV1LocationCities(
  data?: PostApiV1LocationCitiesMutationRequest,
  config: Partial<RequestConfig<PostApiV1LocationCitiesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1LocationCitiesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCities400
      | PostApiV1LocationCities401
      | PostApiV1LocationCities404
      | PostApiV1LocationCities409
      | PostApiV1LocationCities500
    >,
    PostApiV1LocationCitiesMutationRequest
  >({
    method: "POST",
    url: getPostApiV1LocationCitiesUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
